// extracted by mini-css-extract-plugin
export default {"list-wrap":"lLuLu_list-wrap","coupon-container":"gTA3E_coupon-container"};